export const ANDROID_APP_DOWNLOAD_URL = 'https://murumed.com/download-android';
export const IOS_APP_DOWNLOAD_URL = 'https://murumed.com/ios-alpha';

export const APP_STORE_DEEPLINK = 'https://murumed.app.link/MXYfr1lQg4';

export const SUPPORT_EMAIL = 'support@murumed.com';

export const DEFAULT_PLAN = 'INDMWTNCC';
